import { render, staticRenderFns } from "./xmgdFrom.vue?vue&type=template&id=15c21bf7&scoped=true"
import script from "./xmgdFrom.vue?vue&type=script&lang=js"
export * from "./xmgdFrom.vue?vue&type=script&lang=js"
import style0 from "./xmgdFrom.vue?vue&type=style&index=0&id=15c21bf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c21bf7",
  null
  
)

export default component.exports